import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSideDrawerOpen: false,
  automatedHsData: {},
  runAutomatedReqIds: [],
};

const complianceRequest = createSlice({
  name: "complianceRequest",
  initialState,
  reducers: {
    setIsSideDrawer: (state, action) => {
      state.isSideDrawerOpen = action.payload;
    },
    setAutomatedHsData: (state, action) => {
      state.automatedHsData = action.payload;
    },
    setRunAutomatedFlow: (state, action) => {
      state.runAutomatedReqIds = action.payload;
    },
  },
});

export const { setIsSideDrawer, setAutomatedHsData, setRunAutomatedFlow } = complianceRequest.actions;

export default complianceRequest.reducer;
